'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createIframe = createIframe;
exports.createHiddenInput = createHiddenInput;
exports.applyListeners = applyListeners;
function createIframe(url, guid, token) {
    var iframe = document.createElement('iframe');
    iframe.src = url + '/view/iframe/' + guid + '/' + token + '/true';
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('scrolling', 'no');
    iframe.setAttribute('id', 'paymetricIframe');
    iframe.setAttribute('name', 'paymetricIframe');
    iframe.setAttribute('class', 'payment-cc-frame');

    return iframe;
}

function createHiddenInput(token) {
    var input = document.createElement('input');
    input.setAttribute('type', 'hidden');
    input.setAttribute('id', 'AccessToken');
    input.setAttribute('name', 'AccessToken');
    input.setAttribute('value', token);
    return input;
}

function applyListeners() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _onReceive = options.onReceive,
        _onReply = options.onReply,
        _onCardTypeChange = options.onCardTypeChange,
        _onValidate = options.onValidate,
        _onInvalidHandler = options.onInvalidHandler;

    return {
        onReceive: function onReceive(e) {
            console.warn('[Paymetric] onReceive: ' + e);
            _onReceive && _onReceive(e);
        },
        onReply: function onReply(e) {
            console.warn('[Paymetric] onReply: ' + e);
            _onReply && _onReply(e);
        },
        onCardTypeChange: function onCardTypeChange(e) {
            console.warn('[Paymetric] onCardTypeChange: ' + e);
            _onCardTypeChange && _onCardTypeChange(e);
        },
        onValidate: function onValidate(e) {
            console.warn('[Paymetric] onValidate: ' + e);
            _onValidate && _onValidate(e);
        },
        onInvalidHandler: function onInvalidHandler(e) {
            console.warn('[Paymetric] onInvalidHandler: ' + e);
            _onInvalidHandler && _onInvalidHandler(e);
        }
    };
}